export default __webpack_public_path__ + "media/images/clippy_frame-cebc319fd6b2dd17470f5885135b254d.png";